// extracted by mini-css-extract-plugin
export default {"questionMark":"Ezbd9"};